"use client";

import { useEffect } from "react";
import { RedirectLayout } from "./RedirectLayout";
import { RedirectSpinner } from "./RedirectSpinner";

/**
 * Sends a lowercased link on to the same link with its app hash in the stored
 * case. See findCaseCorrectedLinkPath.
 *
 * Not redirect(): the link page streams, so its 200 is already sent by the
 * time the link is looked up, and redirect() can only do a client-side replace
 * to a URL without the fragment. That loses #detour_open_app, so the app never
 * opens. A full navigation that carries the fragment over keeps it.
 */
export function CaseCorrectedRedirect({ path }: { path: string }) {
  useEffect(() => {
    window.location.replace(path + window.location.hash);
  }, [path]);

  return (
    <RedirectLayout appIconSrc={null} appName={null}>
      <RedirectSpinner />
    </RedirectLayout>
  );
}
